/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name: ApprovalFiles.js
 *
 * Description:	Allows support for multiple files across a single approval and renders the navigation icon.
 *				This is dependant on the combo control navigation and essentially is just a helper control for the user.
 *
 * History:		27-JUL-18	J Jackson		Initial implementation.
 *              07-NOV-18   S Norman        Exclude 3D View documents from count when updating the approval icons.
 *
 **/

var g_oApprovalFiles = {

	// Data held about the relevant combo control.
	g_oControlIndex: [],

	/**
	* Sets up the file select icon and class specific information.
	* @param {number} iComboControl - The index of the combo control we are using.
	*/
	Setup: function (iComboControl) {
		// Set the current ApprovalId.
		g_oApprovalFiles.g_oControlIndex[iComboControl] = {};
		g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs = [];
		g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex = 0;

		// Get the files from the combo control.
		var oCompareFiles = g_oaComboControls[iComboControl].documents;

		// Get the selected document from the control.
		var CurrentDocument = g_oaComboControls[iComboControl].documents[g_oaComboControls[iComboControl].selectedDocumentIndex];

		if (typeof (CurrentDocument) !== "undefined" && CurrentDocument.greenlightApprovalId > 0) {

			// Calculate the list of documents on this approval using all the compare documents.
			for (var i = 0; i < oCompareFiles.length; i++) {

				if (oCompareFiles[i].greenlightApprovalId === CurrentDocument.greenlightApprovalId) {
					// If the doc id matches, the one we are about to add is the current indexed value.
					if (CurrentDocument.greenlightDocumentId === oCompareFiles[i].greenlightDocumentId) {
						g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex = g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length;
					}
					g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.push(oCompareFiles[i]);
				}
			}
		}

		// Render / Update.
		g_oApprovalFiles.Render(iComboControl);
		if (iComboControl === 0) {
			g_oApprovalFiles.UpdateApprovalIcons(iComboControl);
		}

	},

	/**
	* Renders the navigation control.
	* @param {number} iComboControl - The index of the combo control we are using.
	*/
	Render: function (iComboControl) {

		// Remove any existing control.
		$("#ApprovalFileSelect_" + iComboControl).remove();

		// If there is more then one doc & the control is usable, render the control.
		if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length > 1 && !g_oaComboControls[iComboControl].readOnly) {
			var backBtnImg = "";
			var nextBtnImg = "";
			// If we are at the first file...
			if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex === 0) {
				backBtnImg = "img/Last-Page_disabled_48.png";
				nextBtnImg = "img/Next-Page_blue_48.png";
			}
			// If we are at the last file...
			else if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex === (g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length - 1)) {
				backBtnImg = "img/Last-Page_blue_48.png";
				nextBtnImg = "img/Next-Page_disabled_48.png";
			}
			else {
				backBtnImg = "img/Last-Page_blue_48.png";
				nextBtnImg = "img/Next-Page_blue_48.png";
			}

			// Build the document navigation for the document control.
			var szHTML = "";
			szHTML += "<div id='ApprovalFileSelect_" + iComboControl + "' style='display: inline; padding-right: 20px; float:left;padding-top: 3px;'>";
			szHTML += "<input type='image' class='multiDocumentSelect tooltip' id='btnMultiDocumentBack_" + iComboControl + "' src='" + backBtnImg + "' title='" + c_szPrevious + "' style='padding-right: 3px;' onclick='g_oApprovalFiles.Previous(" + iComboControl + ");'/>";
			szHTML += "<span id='spnMultiDocumentNumber'>" + (g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex + 1) + " of " + g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length + "</span>";
			szHTML += "<input type='image' class='multiDocumentSelect tooltip' id='btnMultiDocumentForward_" + iComboControl + "' src='" + nextBtnImg + "' title='" + c_szNext + "' style='padding-left: 3px;' onclick='g_oApprovalFiles.Next(" + iComboControl + ");'/>";
			szHTML += "</div>";

			// Append the document navigation.
			if (iComboControl === 0) {
				$("#divApprovalName").append(szHTML);
			}
			else if (iComboControl === 1) {
				$("#divCompareName").append(szHTML);
			}

			// If the rendered control is on a new line, swap the top padding to bottom.
			if ($("#divComboControl_" + iComboControl).position().top !== $("#ApprovalFileSelect_" + iComboControl).position().top) {
				$("#ApprovalFileSelect_" + iComboControl).css('padding-top', 0);
				$("#ApprovalFileSelect_" + iComboControl).css('padding-bottom', 3);
			}
		}
	},

	/**
	* Updates the navigation control information and alters the approve/reject icons.
	* @param {number} iComboControl - The index of the combo control we are using.
	*/
	UpdateApprovalIcons: function (iComboControl) {
		
		// Determine the number of documents on the approval.
		var iNumberofDocs = g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length;

		// Exclude 3D views.
		if (iNumberofDocs > 1) {
			for (var i = 0; i < g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length; i++) {
				if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs[i].document.Approval3DViewId > 0) {
					iNumberofDocs--;
				}
			}
		}

		// If this is a multi document approval.
		if (iNumberofDocs > 1) {

			// Update the button prompts.
			$("#txtApproveButtonPrompt").html(g_oApproval.c_szApprovalApproveAllDocuments + " (" + iNumberofDocs + ")");
			$("#txtConditionalButtonPrompt").html(g_oApproval.c_szApprovalConditionalApproveAllDocuments + " (" + iNumberofDocs + ")");
			$("#txtRejectButtonPrompt").html(g_oApproval.c_szApprovalRejectAllDocuments + " (" + iNumberofDocs + ")");

			// Alter width to better display new prompts.
			$("#btnConfirmApprove").css('width', '200px');
			$("#divApprovalDropDown").css('margin-left', '-85px');
			$("#btnConfirmReject").css('width', '200px');
			$("#divRejectionDropDown").css('margin-left', '-85px');
			$("#btnConfirmConditionalApprove").css('width', '200px');
			$("#divConfirmConditionalApproval").css('margin-left', '0px');
		}
		// If this is a single document approval.
		else {

			// Change the button prompts to that of a single file.
			$("#txtApproveButtonPrompt").html(g_oApproval.c_szApproveButtonApprove);
			$("#txtConditionalButtonPrompt").html(g_oApproval.c_szConditionalApproveButtonApprove);
			$("#txtRejectButtonPrompt").html(g_oApproval.c_szRejectButtonReject);

			// Alter width to better display new prompts.
			$("#btnConfirmApprove").css('width', '120px');
			$("#divApprovalDropDown").css('margin-left', '-45px');
			$("#btnConfirmReject").css('width', '120px');
			$("#divRejectionDropDown").css('margin-left', '-45px');
			$("#btnConfirmConditionalApprove").css('width', '120px');
			$("#divConfirmConditionalApproval").css('margin-left', '0px');
		}
	},

	/**
	 * Event used to move the approval to the next file.
	 * @param {number} iComboControl - Int that represents the file control index.
	 */
	Next: function (iComboControl) {
		if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex !== (g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs.length - 1)) {

			g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex++;
			// Get the files from the combo control.
			var oComboFiles = g_oaComboControls[iComboControl].documents;

			var iControlBoxIndex = 0;
			for (var i = 0; i < oComboFiles.length; i++) {
				if (oComboFiles[i].greenlightDocumentId === g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs[g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex].greenlightDocumentId) {
					iControlBoxIndex = i;
					break;
				}
			}

			// Emulate the control box onclick.
			comboControl_SelectOption(iComboControl, iControlBoxIndex, -1, true);
		}
	},

	/**
	 * Event used to move the approval to the previous file.
	 * @param {number} iComboControl - Int that represents the file control index.
	 */
	Previous: function (iComboControl) {
		if (g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex > 0) {
			g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex--;

			// Get the files from the combo control.
			var oComboFiles = g_oaComboControls[iComboControl].documents;

			// Find this document within the control box.
			var iControlBoxIndex = 0;
			for (var i = 0; i < oComboFiles.length; i++) {
				if (oComboFiles[i].greenlightDocumentId === g_oApprovalFiles.g_oControlIndex[iComboControl].g_Docs[g_oApprovalFiles.g_oControlIndex[iComboControl].g_iCurrentDocIndex].greenlightDocumentId) {
					iControlBoxIndex = i;
					break;
				}
			}
			// Emulate the control box onclick.
			comboControl_SelectOption(iComboControl, iControlBoxIndex, -1, true);
		}
	}
};